import React, { useState } from 'react';
import './FeedbackForm.css'; // Importing the CSS file

const FeedbackForm = ({bizDetails}) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (rating <= 3) {
      // Construct mailto link for users with low ratings
      const subject = encodeURIComponent(bizDetails.feedback.customerServiceRating);
      const body = encodeURIComponent(`التقييم: ${rating}/5\nالملاحظات: ${feedback}`);
      window.location.href = `mailto:info@risto.co.il?subject=${subject}&body=${body}`;
    }
    // For rating > 3, you already have the logic to guide users to Google reviews
  };


  const handleCopyFeedback = () => {
    navigator.clipboard.writeText(feedback);
    alert(bizDetails.feedback.ratingCopied);
  };

  if (!submitted) {
    return (
      <form onSubmit={handleSubmit} className="feedback-form">
        <div className="rating-container">
          <p>{bizDetails.feedback.rateExperience}</p>
          <div className="stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <label key={star} className={`star ${rating >= star ? 'filled' : ''}`}>
                <input
                  type="radio"
                  name="rating"
                  value={star}
                  onChange={() => setRating(star)}
                  className="star-radio"
                />
                ☆
              </label>
            ))}
          </div>
        </div>
        <textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder={bizDetails.feedback.feedbackPlaceholder}
          rows={4}
          className="feedback-textarea"
        />
        <button type="submit" className="submit-button">{bizDetails.feedback.submitRating}</button>
      </form>
    );
  } else {
    return (
      <div className="thank-you-message">
        {rating > 3 ? (
          <>
            <p>{bizDetails.feedback.thankYouPositive} <span role="img" aria-label="love">🧡</span>.</p>
            <div className='google-buttons'>
              <button onClick={handleCopyFeedback} className="copy-button">{bizDetails.feedback.copyRating}</button>
              <a href="https://g.page/r/CQSvRFiWjd1vEBM/review" target="_blank" rel="noopener noreferrer" className="google-link">{bizDetails.feedback.completeGoogleReview}</a>
            </div>
          </>
        ) : (
          <p>{bizDetails.feedback.thankYouImprovement}</p>
        )}
      </div>
    );
  }
};

export default FeedbackForm;
